export default {
  pt_BR: {
    'Close': 'Fechar',
    'You do not have permission': 'Você não tem permissão',
    'Token already registered for the user': 'Token já registrado para o usuário',
    'It was not possible to send the email': 'Não foi possível enviar o email',
    'Token has expired': 'Token expirou',
    'Token not found': 'Token não encontrado',
    'Could not connect to the database': 'Não é possível acessar o banco de dados',
    'Email not found': 'Email não encontrado',
    'TypeError: e.response is undefined': 'Sem conexão com a internet',
    'TypeError: error.response is undefined': 'Sem conexão com a internet',
    "TypeError: Cannot read property 'status' of undefined": 'Sem conexão com a internet',
    'unknown error': 'Erro desconhecido',
    'User not found': 'Usuário não encontrado',
    'Password does not match': 'Senha incorreta',
    'username must match the following: "/^[-A-Za-z0-9_]+$/"': 'Nome de usuário inválido',
    'You must agree to continue': 'Você deve concordar com os termos para continuar',
    'User already exists': 'O nome de usuário ou o email já esta em uso',
    'Email is already in use': 'Email já esta em uso',
    message: {
      controllers: 'Controladores',
      whitespace_is_not_allowed_at_the_beginning: 'Espaço em branco não é permitido no início',
      whitespace_is_not_allowed_at_the_end: 'Espaço em branco não é permitido no final',
      head_info: 'Olá caro usuário, informamos que o InoBram Cloud passou por atualizações e melhorias, caso você tenha algum problema ao acessar sua conta, entre em contato com nosso Setor de Atendimento ao Cliente.',
      consent_term_question: `Eu li e concordo com os `,
      consent_term_for_data_storage_and_use: 'termos e condições de uso',
      consent_term: 'Termo de consentimento',
      as: 'como',
      there_are_no_requests: 'Não existem solicitações',
      email_is_already_in_use: 'Email já esta em uso',
      you_already_have_the_product: 'Você já possui o produto',
      with_the_following_permission: 'com a seguinte permissão',
      there_is_already_a_request: 'Já existe uma solicitação',
      the_product_with_the_token: 'O produto com o token',
      already_have_a_linked_account: 'já possui uma conta vinculada',
      requests_access_to_the_product: 'solicita acesso ao produto',
      requests_access_to_the_product_with_the_token:
        'Solicita acesso ao produto com o token',
      current_password: 'Senha atual',
      new_password: 'Nova senha',
      confirm_new_password: 'Confirme a nova senha',
      current_password_is_required: 'Senha atual é obrigatória',
      new_password_is_required: 'Nova senha é obrigatória',
      confirm_new_password_is_required: 'Confirme a nova senha é obrigatória',
      password_changed_successfully: 'Senha alterada com sucesso',
      change_the_password: 'Alterar a senha',
      email_successfully_sent: 'Email enviado com sucesso',
      email_already_sent: 'Email já enviado!',
      request_new_email: 'Você poderá solicitar um novo email após',
      go_to_login_page: 'Ir para página de login',
      user_registration: 'Cadastro de usuário',
      user_successfully_created: 'Usuário criado com sucesso',
      must_be_at_least_6_characters: 'Deve ter ao menos 6 caracteres',
      password_and_cofirm_password_must_be_the_same:
        'Senha e confirme a senha devem ser iguais',
      special_characters_are_not_allowed:
        'Caracteres especiais não são permitidos',
      only_numbers_are_allowed: 'Somente números são permitidos',
      invalid_data: 'Dados inválidos',
      unknown_error: 'Erro desconhecido',
      incorrect_password: 'Senha incorreta',
      user_not_found_or_incorrect_password:
        'Usuário não encontrado ou senha incorreta',
      send_password_reset_link: 'Enviar link de redefinição de senha',
      come_back: 'Voltar',
      allow: 'Permitir',
      remove_request: 'Remover solicitação',
      access_requests: 'Pedidos de acesso',
      do_you_want_to_request_access: 'Deseja solicitar acesso?',
      read_only: 'Somente leitura',
      administrator: 'Administrador',
      admin: 'Administrador',
      access_permission: 'Permissão de acesso',
      request: 'Solicitar',
      no_registered_product: 'Nenhum produto cadastrado',
      description_is_required: 'Descrição é obrigatória',
      token_is_required: 'Token é obrigatório',
      name_is_required: 'Nome é obrigatório',
      uf_is_required: 'UF é obrigatório',
      city_is_required: 'Cidade é obrigatório',
      address_is_required: 'Endereço é obrigatório',
      phone_is_required: 'Telefone é obrigatório',
      email_is_required: 'Email é obrigatório',
      username_is_required: 'Usuário é obrigatório',
      password_is_required: 'Senha é obrigatório',
      confirm_password_is_required: 'Confirma senha é obrigatório',
      reset_password_question: 'Não consegue acessar sua conta?',
      phone: 'Telefone',
      email: 'Email',
      username: 'Usuário',
      address: 'Endereço',
      access: 'Acessar',
      loading: 'Carregando...',
      model: 'Modelo',
      model_is_required: 'Modelo é obrigatório',
      new_product: 'Novo produto',
      edit_product: 'Editar produto',
      products: 'Produtos',
      new_user: 'Novo usuário?',
      email_must_be_valid: 'Email deve ser válido',
      owner: 'Proprietário',
      birth_day: 'Data de nascimento',
      change: 'Alterar',
      account: 'Conta',
      entries: 'Cadastros',
      date: 'Data',
      initial_date: 'Data inicial',
      final_date: 'Data final',
      reading: 'Leitura',
      readings: 'Leituras',
      statistic: 'Estátistica',
      statistics: 'Estátisticas',
      enter: 'Entrar',
      add: 'Adicionar',
      type: 'Tipo',
      description: 'Descrição',
      indicates_that_the_field_is_required: '*Indica que o campo é obrigatório',
      create_your_account: 'Crie sua conta',
      create: 'Criar',
      cancel: 'Cancelar',
      save: 'Salvar',
      save_for_all: 'Salvar para todos',
      name: 'Nome',
      password: 'Senha',
      confirm_the_password: 'Confirme a senha',
      password_must_be_at_least_6_characters:
        'A senha deve ter ao menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password:
        'A senha é inválida ou o usuário não possui uma senha.',
      the_email_address_is_badly_formatted:
        'O endereço de email está mal formatado.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted:
        'Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído.',
      profile: 'Perfil',
      users: 'Usuários',
      users_of: 'Usuários de',
      add_user: 'Adicionar usuário',
      updated_at: 'Atualizado em',
      yes: 'Sim',
      no: 'Não',
      alerts: 'Alertas',
      settings: 'Configurações',
      inobram_account: 'Conta da Inobram',
      exit: 'Sair',
      added_at: 'Adicionado em',
      added_by: 'Adicionado por',
      edit: 'Editar',
      delete: 'Excluir',
      close: 'Fechar',
      all: 'Todos',
      rows_per_page: 'Linhas por página',
      no_data: 'Nenhum dado disponível',
      items_to_show: 'Itens para mostrar',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Padrão do MAC inválido',
      to_view: 'Visualizar',
      next: 'Próximo',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Cidades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Cidade',
      sex: 'Sexo',
      transfer: 'Transferir',
      transfer_product: 'Transferir produto',
      old_mac: 'Antigo MAC',
      new_mac: 'Novo MAC',
      generate_token: 'Gerar token',
      mac_address: 'Endereço MAC',
      token: 'Token',
      your_session_has_expired: 'Sua sessão expirou',
      copy_token: 'Copiar token',
      application_support: 'Suporte da aplicação',
      application_support_phone: '(46) 3025-9584',
      skip: 'Pular',
      find_user_information: 'Visualize todas as informações de acesso para cada produto',
      find_user_information_description: 'Clique no ícone USUÁRIOS na tela de produtos e verifique todos os usuários com permissão de acesso administrador ou somente leitura para cada produto.',
      location_permission: 'Gerencie as permissões de acesso',
      location_permission_description: 'Como usuário administrador, você pode remover ou alterar as permissões para cada usuário com acesso aos produtos.',
      set_language_profile: 'Escolha o idioma de sua preferência',
      set_language_profile_description: 'Clique na bandeira corresponde ao idioma desejado: português, inglês ou espanhol.',
      request_access_icon: 'Responda rapidamente as solicitações de acesso aos produtos',
      request_access_icon_description: 'Na barra superior existe um novo ícone para visualizar, configurar e responder todas as requisições de nível de acesso para novos usuários.',
      additional_fields: 'Tenha a localização precisa de cada produto',
      additional_fields_description: 'Ao cadastrar um novo produto, use os campos Brasil, estado e cidade para informar a localização.',
      reset_password_funcionality: 'Redefina a sua senha rapidamente',
      reset_password_funcionality_description: 'Na tela de login, clique em “Não consegue acessar a sua conta?”, insira seu e-mail, faça a solicitação e cadastre uma nova senha.',
      or: "ou",
      call_to: "Ligue para:",
      to_silence: "Silenciar",
      send_an_email: "Envie um email:",
      get_in_touch: "Entrar em contato",
      whatsapp_clicking_below: "Ou chame no WhatsApp clicando no botão abaixo.",
      you_have_some_devices: "Se você possui algum dispositivo dos modelos",
      dont_show_this_message_again: "Não mostrar essa mensagem novamente",
      use_our_help_channels: "Utilize nossos canais de atendimento para te ajudarmos no processo.",
      you_need_to_update_your_device: "será necessário manter seu equipamento atualizado para que o InoBram App continue auxiliando no dia a dia da granja."
    },
    notification: {
      attention: 'Atenção',
      confirm_exclusion: 'Confirma exclusão?',
      deleted_successfully: 'Excluído com sucesso!',
      saved_successfully: 'Salvo com sucesso!',
      there_was_an_error_saving: 'Ocorreu um erro ao salvar',
      there_was_an_error: 'Ocorreu um erro'
    },
    table: {
      of: 'de',
      all: 'Todas',
      rows_per_page_text: 'Linhas por página'
    }
  },
  en_US: {
    'Close': 'Close',
    'You do not have permission': 'You do not have permission',
    'Token already registered for the user': 'Token already registered for the user',
    'It was not possible to send the email': 'It was not possible to send the email',
    'Token has expired': 'Token has expired',
    'Token not found': 'Token not found',
    'Could not connect to the database': 'Could not connect to the database',
    'Email not found': 'Email not found',
    'TypeError: e.response is undefined': 'Without internet connection',
    'TypeError: error.response is undefined': 'Without internet connection',
    "TypeError: Cannot read property 'status' of undefined": 'Without internet connection',
    'unknown error': 'Unknown error',
    'User not found': 'User not found',
    'Password does not match': 'Password does not match',
    'username must match the following: "/^[-A-Za-z0-9_]+$/"': 'Invalid username',
    'You must agree to continue': 'You must agree the terms to continue',
    'User already exists': 'The username or email is already in use',
    'Email is already in use': 'Email is already in use',
    message: {
      controllers: 'Controllers',
      whitespace_is_not_allowed_at_the_beginning: 'Whitespace is not allowed at the beginning',
      whitespace_is_not_allowed_at_the_end: 'Whitespace is not allowed at the end',
      head_info: 'Hello dear user, we inform you that InoBram Cloud has undergone updates and improvements, if you have any problems accessing your account, please contact our Customer Service Department.',
      consent_term_question: `I have read and agree to the `,
      consent_term_for_data_storage_and_use: 'terms and conditions of use',
      consent_term: 'Consent term',
      as: 'with',
      there_are_no_requests: 'There are no requests',
      email_is_already_in_use: 'Email is already in use',
      you_already_have_the_product: 'You already have the product',
      with_the_following_permission: 'with the following permission',
      there_is_already_a_request: 'There is already a request',
      the_product_with_the_token: 'The product with the token',
      already_have_a_linked_account: 'already have a linked account',
      requests_access_to_the_product: 'requests access to the product',
      requests_access_to_the_product_with_the_token:
        'Requests access to the product with the token',
      current_password: 'Current password',
      new_password: 'New password',
      confirm_new_password: 'Confirm new password',
      current_password_is_required: 'Current password is required',
      new_password_is_required: 'New password is required',
      confirm_new_password_is_required: 'Confirm new password is required',
      password_changed_successfully: 'Password changed successfully',
      change_the_password: 'Change password',
      email_successfully_sent: 'Email successfully sent',
      email_already_sent: 'Email already sent!',
      request_new_email: 'You can request a new email after',
      go_to_login_page: 'Go to login page',
      user_registration: 'User registration',
      user_successfully_created: 'User successfully created',
      must_be_at_least_6_characters: 'Must be at least 6 characters',
      password_and_cofirm_password_must_be_the_same:
        'Password and confirm password must be the same',
      special_characters_are_not_allowed: 'Special characters are not allowed',
      only_numbers_are_allowed: 'Only numbers are allowed',
      invalid_data: 'Invalid data',
      unknown_error: 'unknown error',
      incorrect_password: 'Incorrect password',
      user_not_found_or_incorrect_password:
        'User not found or incorrect password',
      send_password_reset_link: 'Send password reset link',
      come_back: 'Come back',
      allow: 'Allow',
      remove_request: 'Remove request',
      access_requests: 'Access requests',
      do_you_want_to_request_access: 'Do you want to request access?',
      read_only: 'Read only',
      administrator: 'Administrator',
      admin: 'Administrator',
      access_permission: 'Access permission',
      request: 'Request',
      no_registered_product: 'No registered product',
      description_is_required: 'Description is required',
      token_is_required: 'Token is required',
      name_is_required: 'Name is required',
      uf_is_required: 'UF is required',
      city_is_required: 'City is required',
      address_is_required: 'Address is required',
      phone_is_required: 'Phone is required',
      email_is_required: 'Email is required',
      username_is_required: 'Username is required',
      password_is_required: 'Password is required',
      confirm_password_is_required: 'Confirm password is required',
      reset_password_question: 'Can not access your account?',
      phone: 'Phone number',
      email: 'Email',
      username: 'Username',
      address: 'Address',
      access: 'Access',
      loading: 'Loading...',
      model: 'Model',
      model_is_required: 'Model is required',
      new_product: 'New product',
      edit_product: 'Edit product',
      products: 'Products',
      new_user: 'New user?',
      email_must_be_valid: 'Email must be valid',
      owner: 'Owner',
      birth_day: 'Birth day',
      change: 'Change',
      account: 'Account',
      entries: 'Entries',
      date: 'Date',
      initial_date: 'Initial date',
      final_date: 'Final date',
      reading: 'Reading',
      readings: 'Readings',
      statistic: 'Statistic',
      statistics: 'Statistics',
      enter: 'Enter',
      add: 'Add',
      type: 'Type',
      description: 'Description',
      indicates_that_the_field_is_required:
        '*Indicates that the field is required',
      create_your_account: 'Create your account',
      create: 'Create',
      cancel: 'Cancel',
      save: 'Save',
      save_for_all: 'Save for all',
      name: 'Name',
      password: 'Password',
      confirm_the_password: 'Confirm the password',
      password_must_be_at_least_6_characters:
        'Password must be at least 6 characters',
      the_password_is_invalid_or_the_user_does_not_have_a_password:
        'The password is invalid or the user does not have a password.',
      the_email_address_is_badly_formatted:
        'The email address is badly formatted.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted:
        'There is no user record corresponding to this identifier. The user may have been deleted.',
      profile: 'Profile',
      users: 'Users',
      users_of: 'Users of',
      add_user: 'Add user',
      updated_at: 'Updated at',
      yes: 'Yes',
      no: 'No',
      alerts: 'Alerts',
      settings: 'Settings',
      inobram_account: 'Inobram account',
      exit: 'Exit',
      added_at: 'Added at',
      added_by: 'Added by',
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      all: 'All',
      rows_per_page: 'Rows per page',
      no_data: 'No data available',
      items_to_show: 'Items to show',
      invalid_mac: 'Invalid MAC',
      invalid_mac_pattern: 'Invalid MAC pattern',
      next: 'Next',
      previous: 'Previus',
      countries: 'Countries',
      states: 'States',
      cities: 'Cities',
      sexes: 'Sexes',
      country: 'Country',
      state: 'State',
      city: 'City',
      sex: 'Sex',
      transfer: 'Transfer',
      transfer_product: 'Transfer product',
      old_mac: 'Old MAC',
      new_mac: 'New MAC',
      generate_token: 'Generate token',
      mac_address: 'MAC Address',
      token: 'Token',
      your_session_has_expired: 'Your session has expired',
      copy_token: 'Copy token',
      application_support: 'Application Support',
      application_support_phone: '(46) 3025-9584',
      skip: 'Skip',
      find_user_information: 'View all access information for each product',
      find_user_information_description: 'Click on the USERS icon on the products screen and check all users with administrator or read-only access permission for each product.',
      location_permission: 'Manage access permissions',
      location_permission_description: 'As an administrator user, you can remove or change permissions for each user with access to the products.',
      set_language_profile: 'Choose your preferred language',
      set_language_profile_description: 'Click on the flag corresponding to the desired language: Portuguese, English or Spanish.',
      request_access_icon: 'Respond quickly to product access requests',
      request_access_icon_description: 'In the top bar there is a new icon to view, configure and respond to all access level requests for new users.',
      additional_fields: 'Get the precise location of each product',
      additional_fields_description: 'When registering a new product, use the Brazil, state and city fields to inform the location.',
      reset_password_funcionality: 'Reset your password quickly',
      reset_password_funcionality_description: 'On the login screen, click on “Can not access your account?”, Enter your email, make the request and register a new password.',
      or: "or",
      call_to: "Call to:",
      to_silence: "Silence",
      send_an_email: "Send an e-mail:",
      get_in_touch: "Get in touch",
      whatsapp_clicking_below: "Or contact us on WhatsApp by clicking the button below.",
      you_have_some_devices: "If you have any device from this models",
      dont_show_this_message_again: "Don't show this message again",
      use_our_help_channels: "Use our service channels to help you through the process.",
      you_need_to_update_your_device: "it will be necessary to keep your equipment up to date for the InoBram App to continue assisting the daily operations of the farm."
    },
    notification: {
      attention: 'Attention',
      confirm_exclusion: 'Confirm exclusion?',
      deleted_successfully: 'Deleted successfully!',
      saved_successfully: 'Saved successfully!',
      there_was_an_error_saving: 'There was an error saving',
      there_was_an_error: 'There was an error'
    },
    table: {
      of: 'of',
      all: 'All',
      rows_per_page_text: 'Rows per page'
    }
  },
  es_ES: {
    'Close': 'Cerrar',
    'You do not have permission': 'No tienes permiso',
    'Token already registered for the user': 'Token ya registrado para el usuário',
    'It was not possible to send the email': 'No fue posible enviar el correo electrónico',
    'Token has expired': 'El token ha expirado',
    'Token not found': 'Token no encontrado',
    'Could not connect to the database': 'No puede acceder a la base de datos',
    'Email not found': 'Correo electrónico no encontrado',
    'TypeError: e.response is undefined': 'Sin conexión a internet',
    'TypeError: error.response is undefined': 'Sin conexión a internet',
    "TypeError: Cannot read property 'status' of undefined": 'Sin conexión a internet',
    'unknown error': 'Error desconocido',
    'User not found': 'Usuario no encontrado',
    'Password does not match': 'Contraseña no coincide',
    'username must match the following: "/^[-A-Za-z0-9_]+$/"': 'Nombre de usuario no válido',
    'You must agree to continue': 'Debes aceptar los términos para continuar',
    'User already exists': 'El nombre de usuario o email ya está en uso',
    'Email is already in use': 'Email ya está en uso',
    message: {
      controllers: 'Controladores',
      whitespace_is_not_allowed_at_the_beginning: 'No se permiten espacios en blanco al principio',
      whitespace_is_not_allowed_at_the_end: 'No se permiten espacios en blanco al final',
      head_info: 'Hola estimado usuario, te informamos que InoBram Cloud ha sido actualizado y mejorado, si tienes algún problema para acceder a tu cuenta, por favor contacta con nuestro Departamento de Atención al Cliente.',
      consent_term_question: `He leído y acepto los `,
      consent_term_for_data_storage_and_use: 'términos y condiciones de uso',
      consent_term: 'Formulario de consentimiento',
      as: 'como',
      there_are_no_requests: 'No hay solicitudes',
      email_is_already_in_use: 'Email ya está en uso',
      you_already_have_the_product: 'Ya tienes el producto',
      with_the_following_permission: 'com a seguinte permissão',
      there_is_already_a_request: 'Ya hay una solicitud',
      the_product_with_the_token: 'El producto con el token',
      already_have_a_linked_account: 'ya tengo una cuenta vinculda',
      requests_access_to_the_product: 'solicita acesso al producto',
      requests_access_to_the_product_with_the_token:
        'Solicita acesso al producto con el token',
      current_password: 'Contraseña actual',
      new_password: 'Nueva contraseña',
      confirm_new_password: 'Confirma la nueva contraseña',
      current_password_is_required: 'Se requiere contraseña actual',
      new_password_is_required: 'Se requiere nueva contraseña',
      confirm_new_password_is_required: 'Se requiere confirme nueva contraseña',
      password_changed_successfully: 'Contraseña alterada com éxito',
      change_the_password: 'Cambiar contraseña',
      email_successfully_sent: 'Email enviado com éxito',
      email_already_sent: 'Email already sent!',
      request_new_email: 'Puede solicitar un nuevo correo electrónico después',
      go_to_login_page: 'Ir para la página de login',
      user_registration: 'Registro de usuario',
      user_successfully_created: 'Usuario creado com éxito',
      must_be_at_least_6_characters: 'Debe tener al menos 6 caracteres',
      password_and_cofirm_password_must_be_the_same:
        'Contraseña y confirme que la contraseña debe ser la misma',
      special_characters_are_not_allowed:
        'No se permiten caracteres especiales',
      only_numbers_are_allowed: 'Solo se permiten números',
      invalid_data: 'Datos inválidos',
      unknown_error: 'Error desconocido',
      incorrect_password: 'Contraseña incorrecta',
      user_not_found_or_incorrect_password:
        'Usuario no encontrado o contraseña incorrecta',
      send_password_reset_link: 'Enviar link de restablecimiento de contraseña',
      come_back: 'Volver',
      allow: 'Permitir',
      remove_request: 'Eliminar solicitud',
      access_requests: 'Solicitudes de acceso',
      do_you_want_to_request_access: '¿Quieres solicitar acceso?',
      read_only: 'Solo lectura',
      administrator: 'Administrador',
      admin: 'Administrador',
      access_permission: 'Permiso de acceso',
      request: 'Solicitud',
      no_registered_product: 'Sin productos registrados',
      description_is_required: 'Se requiere el descripción',
      token_is_required: 'Se requiere el token',
      name_is_required: 'Se requiere el nombre',
      uf_is_required: 'Se requiere el UF',
      city_is_required: 'Se requiere el ciudad',
      address_is_required: 'Se requiere el dirección',
      phone_is_required: 'Se requiere el telefone',
      email_is_required: 'Se requiere el Email',
      username_is_required: 'Se requiere el nombre de usuario',
      password_is_required: 'Se requiere el contraseña',
      confirm_password_is_required: 'Se requiere el confirmar contraseña',
      reset_password_question: '¿No puedes acceder a tu cuenta?',
      phone: 'Telefono',
      email: 'Email',
      username: 'Nombre de usuario',
      address: 'Dirección',
      access: 'Acessar',
      loading: 'Cargando...',
      model: 'Modelo',
      model_is_required: 'Se requiere el Modelo',
      new_product: 'Nuevo Producto',
      edit_product: 'Editar producto',
      products: 'Productos',
      new_user: '¿Nuevo usuario?',
      email_must_be_valid: 'El Email debe ser válido',
      owner: 'Dueño',
      birth_day: 'Fecha de nacimiento',
      change: 'Alterar',
      account: 'Cuenta',
      entries: 'Entradas',
      date: 'Fecha',
      initial_date: 'Fecha inicial',
      final_date: 'Fecha final',
      reading: 'Lectura',
      readings: 'Lecturas',
      statistic: 'Estadística',
      statistics: 'Estadísticas',
      enter: 'Entrar',
      add: 'Añadir',
      type: 'Especie',
      description: 'Descripción',
      indicates_that_the_field_is_required:
        '*Indica que el campo es obligatorio',
      create_your_account: 'Crea tu cuenta',
      create: 'Crear',
      cancel: 'Cancelar',
      save: 'Guardar',
      save_for_all: 'Guadar para todos',
      name: 'Nombre',
      password: 'Contraseña',
      confirm_the_password: 'Confirme la contraseña',
      password_must_be_at_least_6_characters:
        'La contraseña debe tener al menos 6 caracteres',
      the_password_is_invalid_or_the_user_does_not_have_a_password:
        'La contraseña no es válida o el usuario no tiene una contraseña.',
      the_email_address_is_badly_formatted:
        'La dirección de correo electrónico está mal formateada.',
      there_is_no_user_record_corresponding_to_this_identifier_the_user_may_have_been_deleted:
        'No hay registro de usuario correspondiente a este identificador. El usuario puede haber sido eliminado.',
      profile: 'Perfil',
      users: 'Usuarios',
      users_of: 'Usuarios de',
      add_user: 'Añadir usuario',
      updated_at: 'Actualizado en',
      yes: 'Si',
      no: 'No',
      alerts: 'Alertas',
      settings: 'Ajustes',
      inobram_account: 'Cuenta Inobram',
      exit: 'Salida',
      added_at: 'Añadido a',
      added_by: 'Añadido por',
      edit: 'Editar',
      delete: 'Borrar',
      close: 'Cerrar',
      all: 'Todos',
      rows_per_page: 'Líneas por página',
      no_data: 'Datos no disponibles',
      items_to_show: 'Elementos para mostrar',
      invalid_mac: 'MAC inválido',
      invalid_mac_pattern: 'Patrón de MAC no válido',
      next: 'Siguiente',
      previous: 'Anterior',
      countries: 'Países',
      states: 'Estados',
      cities: 'Ciudades',
      sexes: 'Sexos',
      country: 'País',
      state: 'Estado',
      city: 'Ciudad',
      sex: 'Sexo',
      transfer: 'Transferir',
      transfer_product: 'Transferir producto',
      old_mac: 'Antiguo MAC',
      new_mac: 'Nuevo MAC',
      generate_token: 'Generar token',
      mac_address: 'Dirección MAC',
      token: 'Token',
      your_session_has_expired: 'Su sesión ha expirado',
      copy_token: 'Token de copia',
      application_support: 'Soporte de la Aplicación',
      application_support_phone: '(46) 3025-9584',
      skip: 'Omitir',
      find_user_information: 'Ver toda la información de acceso para cada producto',
      find_user_information_description: 'Haga clic en el ícono USUARIOS en la pantalla de productos y verifique a todos los usuarios con permisos de administrador o de acceso de solo lectura para cada producto.',
      location_permission: 'Administrar permisos de acceso',
      location_permission_description: 'Como usuario administrador, puede eliminar o cambiar los permisos de cada usuario con acceso a los productos.',
      set_language_profile: 'Elija su idioma preferido',
      set_language_profile_description: 'Haga clic en la bandera correspondiente al idioma deseado: portugués, inglés o español.',
      request_access_icon: 'Responda rápidamente a las solicitudes de acceso a productos',
      request_access_icon_description: 'En la barra superior hay un nuevo icono para ver, configurar y responder a todas las solicitudes de nivel de acceso para nuevos usuarios.',
      additional_fields: 'Obtenga la ubicación precisa de cada producto',
      additional_fields_description: 'Al registrar un nuevo producto, utilice los campos Brasil, estado y ciudad para informar la ubicación.',
      reset_password_funcionality: 'Restablece tu contraseña rápidamente',
      reset_password_funcionality_description: 'En la pantalla de inicio de sesión, haga clic en "¿No puede acceder a su cuenta?", Ingrese su correo electrónico, realice la solicitud y registre una nueva contraseña.',
      or: "o",
      call_to: "Llamar a:",
      to_silence: "Silenciar",
      send_an_email: "Enviar un e-mail:",
      get_in_touch: "Entrar en contacto",
      whatsapp_clicking_below: "O contáctenos en WhatsApp haciendo clic en el botón de abajo.",
      you_have_some_devices: "Si tienes algún dispositivo de los modelos",
      dont_show_this_message_again: "No volver a mostrar este mensaje",
      use_our_help_channels: "Utilice nuestros canales de servicio para ayudarlo durante el proceso.",
      you_need_to_update_your_device: "Será necesario mantener su equipo actualizado para que la aplicación InoBram continúe ayudando en la vida diaria de la granja."
    },
    notification: {
      attention: 'Atención',
      confirm_exclusion: 'Confirma la exclusíon?',
      deleted_successfully: 'Eliminado con éxito!',
      saved_successfully: 'Salvo con éxito!',
      there_was_an_error_saving: 'Hubo un error guardando',
      there_was_an_error: 'Hubo un error'
    },
    table: {
      of: 'de',
      all: 'Todos',
      rows_per_page_text: 'Líneas por página'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/index.js